// Base error class
class HttpError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

/**
 * Status code: 401 - Unauthorized
 */
export class UnauthorizedError extends HttpError {}

/**
 * Status code: 409 - Conflict
 */
export class ConflictError extends HttpError {}

/**
 * Status code: 400 - Bad Request
 */
export class BadRequestError extends HttpError {}

/**
 * Status code: 403 - Forbidden
 */
export class ForbiddenError extends HttpError {}

/**
 * Status code: 404 - Not Found
 */
export class NotFoundError extends HttpError {}

/**
 * Status code: 500 - Internal Server Error
 */
export class InternalServerError extends HttpError {}

/**
 * Status code: 502 - Bad Gateway
 */
export class BadGatewayError extends HttpError {}

/**
 * Status code: 503 - Service Unavailable
 */
export class ServiceUnavailableError extends HttpError {}

/**
 * Status code: 504 - Gateway Timeout
 */
export class GatewayTimeoutError extends HttpError {}
